import React from 'react';
type SectionHeadingProps = {
  id: string;
  children: React.ReactNode;
  className?: string;
};
export function SectionHeading({
  id,
  children,
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-232" data-mp="vytka0m3k6hk">
      <h2 id={id} className="mx-auto max-w-3xl text-balance font-display text-4xl font-extrabold uppercase leading-[1.02] tracking-tight text-foreground sm:text-5xl" data-id="element-233" data-mp="vxjo5gyt18dk">
        {children}
      </h2>
      <span className="mx-auto mt-5 flex w-fit items-center gap-1.5" aria-hidden="true" data-id="element-234" data-mp="mzzizwxtmrxo">
        <span className="h-1 w-12 rounded-full bg-electric shadow-[0_0_10px_rgba(0,207,255,0.6)]" data-id="element-235" data-mp="i6di1210schp" />
        <span className="h-1 w-4 rounded-full bg-gold" data-id="element-236" data-mp="d9epup0x2fm5" />
      </span>
    </div>;
}